import {
    TransactionDocumentEstimateActivityLineItem,
    TransactionDocumentEstimateTransactionLineItem,
    TransactionDocumentEstimateTransportationLineItem,
} from '@lune-climate/lune'
import type { TransactionDocumentEmissionEstimateLineItem } from '@lune-climate/lune/cjs/models/TransactionDocumentEmissionEstimateLineItem'
import { None, Option, Some } from 'ts-results-es'

export function asTransactionLineItemForExplanation(
    lineItem: TransactionDocumentEmissionEstimateLineItem,
): Option<
    TransactionDocumentEstimateTransactionLineItem &
        Pick<TransactionDocumentEmissionEstimateLineItem, 'value' | 'mass'>
> {
    return lineItem.type === 'transaction' && 'exchangeRateDate' in lineItem ? Some(lineItem) : None
}

export function asActivityTransactionLineItemForExplanation(
    lineItem: TransactionDocumentEmissionEstimateLineItem,
): Option<
    TransactionDocumentEstimateActivityLineItem &
        Pick<TransactionDocumentEmissionEstimateLineItem, 'value' | 'mass'>
> {
    return lineItem.type === 'activity_transaction' && 'activity' in lineItem
        ? Some(lineItem)
        : None
}

export function asPassengerTransportationLineItemForExplanation(
    lineItem: TransactionDocumentEmissionEstimateLineItem,
): Option<
    TransactionDocumentEstimateTransportationLineItem &
        Pick<TransactionDocumentEmissionEstimateLineItem, 'value' | 'mass'>
> {
    return lineItem.type === 'passenger_transportation' && 'passengers' in lineItem
        ? Some(lineItem)
        : None
}
